module.exports = __webpack_public_path__ + "media/images/companies/tabimusha-14da22c9b3242c959ad8c63472a4f9e8.png";